import { Skeleton } from "@/components/ui/skeleton";

export const BlogCardSkeleton = () => (
  <div className="bg-card rounded-xl border border-border overflow-hidden">
    <Skeleton className="h-44 w-full rounded-none" />
    <div className="p-5 space-y-3">
      <Skeleton className="h-3 w-16" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-2/3" />
      <Skeleton className="h-3 w-20 mt-2" />
    </div>
  </div>
);

export const FeaturedCardSkeleton = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 bg-card rounded-xl border border-border overflow-hidden">
    <Skeleton className="h-64 md:h-80 w-full rounded-none" />
    <div className="p-6 md:p-8 flex flex-col justify-center space-y-4">
      <Skeleton className="h-3 w-16" />
      <Skeleton className="h-7 w-full" />
      <Skeleton className="h-7 w-3/4" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-2/3" />
      <div className="flex gap-4 pt-2">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-16" />
      </div>
    </div>
  </div>
);

export const BlogPageSkeleton = () => (
  <div className="flex min-h-screen flex-col bg-background">
    {/* Hero skeleton */}
    <Skeleton className="h-48 w-full rounded-none" />
    
    <div className="container mx-auto px-4 py-16 max-w-5xl space-y-16">
      {/* Featured */}
      <FeaturedCardSkeleton />
      
      {/* Grid */}
      <div className="space-y-8">
        <Skeleton className="h-7 w-40" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <BlogCardSkeleton key={i} />
          ))}
        </div>
      </div>
    </div>
  </div>
);
